import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Icon, Table, Card, Input, Button, Popup, Loader} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {paths} from '../../../../common/dictionaries/urls';
import {Actions} from '../../../../common/actions';

class ZonesList extends Component {
  constructor(props) {
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingZones,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.changeZonesTextFilter('');
    this.props.fetchZonesList();
  }

  onFilterChange(event) {
    this.props.changeZonesTextFilter(event.target.value);
    this.props.filterZones(event.target.value);
  }

  renderCreateButton() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingZones,
        scopes.Create
      )
    ) {
      return null;
    }

    return (
      <Button
        primary
        className='toyota-primary'
        as={Link}
        to='/picking/zonas/nuevo'
      >
        Nueva Zona
      </Button>
    );
  }

  renderActionsCell(element) {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingZones,
        scopes.Edit
      )
    ) {
      return null;
    }

    return (
      <Table.Cell textAlign='center'>
        <Popup
          trigger={
            <Link to={`/picking/zonas/editar/${element.code}`}>
              <Icon name='write' color='blue' size='large' />
            </Link>
          }
          content='Editar'
          position='top center'
          inverted
        />
      </Table.Cell>
    );
  }

  renderZones(list) {
    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }

    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.name}</Table.Cell>
          <Table.Cell textAlign='center'>{element.lines}</Table.Cell>
          <Table.Cell textAlign='center'>{element.pickingTime}</Table.Cell>
          <Table.Cell textAlign='center'>{element.people}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.status ? 'Activo' : 'Inactivo'}
          </Table.Cell>
          {this.renderActionsCell(element)}
        </Table.Row>
      );
    });
  }

  renderLoaderOrZones(list) {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderZones(list);
  }

  renderActionsHeader() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.PickingZones,
        scopes.Edit
      )
    ) {
      return null;
    }

    return <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>;
  }

  render() {
    const {zones, filterText} = this.props;
    return (
      <div className='zones-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Mantenimiento de Zonas y Ubicaciones</h2>
              <div className='title-bar-actions'>
                <Input
                  icon='search'
                  placeholder='Buscar'
                  value={filterText}
                  onChange={this.onFilterChange}
                />
                {this.renderCreateButton()}
              </div>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Nombre</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  No. Líneas
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Tiempo Recolección (minutos)
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Recurso (personal)
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
                {this.renderActionsHeader()}
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderLoaderOrZones(zones)}</Table.Body>
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loding': state.zones.loading,
    'zones': state.zones.filteredList,
    'filterText': state.zones.filterText,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {fetchZonesList, filterZones, changeZonesTextFilter, navigateTo} =
  Actions;

export default connect(mapStateToProps, {
  fetchZonesList,
  filterZones,
  changeZonesTextFilter,
  navigateTo,
})(ZonesList);
